(function () {
  'use strict';

  var root = document.querySelector('[data-cinema-home]');
  if (!root) return;

  var clamp = function (n) { return Math.min(1, Math.max(0, n)); };
  var pad = function (n) { return String(n).padStart(3, '0'); };
  var canvas = root.querySelector('[data-cinema-canvas]');
  var section = root.querySelector('[data-cinema-section]');
  var progressLine = root.querySelector('[data-page-progress]');
  var scrubLine = root.querySelector('[data-scrub-progress]');
  var beats = Array.prototype.slice.call(root.querySelectorAll('[data-beat]'));
  var districtSection = root.querySelector('[data-district-section]');
  var districtStage = root.querySelector('[data-district-stage]');
  var districts = Array.prototype.slice.call(root.querySelectorAll('[data-district]'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-district-dot]'));
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (canvas && section) {
    var ctx = canvas.getContext('2d', { alpha: true });
    var mobile = window.matchMedia('(max-width:820px)').matches;
    var total = mobile ? 172 : 275;
    var base = mobile ? root.dataset.mobileBase : root.dataset.desktopBase;
    var images = new Array(total);
    var requested = {};
    var queue = [];
    var active = 0;
    var sized = { width: 0, height: 0 };
    var smooth = 0;

    var frameUrl = function (index) {
      var name = mobile ? 'kino-m-' : 'kino-d-';
      return base.replace(new RegExp(name + '\\d{3}\\.webp'), name + pad(index) + '.webp');
    };

    var pump = function () {
      while (active < 6 && queue.length) {
        (function (index) {
          active += 1;
          var image = new Image();
          image.decoding = 'async';
          image.onload = function () { images[index] = image; active -= 1; pump(); };
          image.onerror = function () { active -= 1; pump(); };
          image.src = frameUrl(index);
        })(queue.shift());
      }
    };

    var request = function (index, front) {
      if (index < 0 || index >= total || requested[index]) return;
      requested[index] = true;
      if (front) queue.unshift(index); else queue.push(index);
    };

    var resize = function () {
      var ratio = Math.min(1.5, window.devicePixelRatio || 1);
      var width = Math.round(canvas.clientWidth * ratio);
      var height = Math.round(canvas.clientHeight * ratio);
      if (width === sized.width && height === sized.height) return;
      canvas.width = width;
      canvas.height = height;
      sized = { width: width, height: height };
    };

    var nearest = function (index) {
      for (var step = 0; step < total; step += 1) {
        if (images[index - step]) return images[index - step];
        if (images[index + step]) return images[index + step];
      }
    };

    var paint = function (index) {
      var image = images[index] || nearest(index);
      if (!image || !ctx) return;
      /* Einpassen statt fuellen: die Sequenz steht auf Schwarz, deshalb faellt
         kein Rand auf. Beim Fuellen wurde die Bohne oben und unten abgeschnitten,
         sobald das Fenster nicht genau 16:9 war. */
      var scale = Math.min(sized.width / image.width, sized.height / image.height);
      var width = image.width * scale;
      var height = image.height * scale;
      ctx.clearRect(0, 0, sized.width, sized.height);
      ctx.drawImage(image, (sized.width - width) / 2, (sized.height - height) / 2, width, height);
    };

    request(0, true);
    pump();

    var update = function () {
      var maxPage = document.documentElement.scrollHeight - window.innerHeight;
      if (progressLine) progressLine.style.transform = 'scaleX(' + (maxPage > 0 ? window.scrollY / maxPage : 0) + ')';

      var rect = section.getBoundingClientRect();
      var distance = section.offsetHeight - window.innerHeight;
      var raw = distance > 0 ? clamp(-rect.top / distance) : 0;
      var mapped = clamp((raw - .03) / .87);
      var target = mapped * (total - 1);
      smooth += (target - smooth) * (reduced ? 1 : .18);
      var index = Math.round(smooth);

      if (scrubLine) scrubLine.style.width = (raw * 100) + '%';
      beats.forEach(function (beat) {
        var start = Number(beat.dataset.start);
        var end = Number(beat.dataset.end);
        var middle = (start + end) / 2;
        var half = (end - start) / 2;
        var near = 1 - Math.min(1, Math.abs(raw - middle) / half);
        beat.style.opacity = clamp(near * 1.8);
        beat.style.transform = 'translate3d(-50%, calc(-50% + ' + ((1 - near) * 18) + 'px), 0)';
      });

      if (rect.top < window.innerHeight && rect.bottom > 0) {
        resize();
        paint(index);
        for (var offset = 0; offset <= 8; offset += 1) {
          request(index + offset, true);
          request(index - offset, true);
        }
        pump();
      }

      if (districtSection && districts.length) {
        var districtRect = districtSection.getBoundingClientRect();
        var districtDistance = districtSection.offsetHeight - window.innerHeight;
        var districtRaw = districtDistance > 0 ? clamp(-districtRect.top / districtDistance) : 0;
        var districtIndex = Math.min(districts.length - 1, Math.floor(clamp((districtRaw - .16) / .62) * districts.length));
        districts.forEach(function (district, i) { district.classList.toggle('is-active', i === districtIndex); });
        dots.forEach(function (dot, i) { dot.classList.toggle('on', i === districtIndex); });
        if (districtStage) districtStage.style.backgroundColor = districts[districtIndex].dataset.background;
      }

      window.requestAnimationFrame(update);
    };

    window.setTimeout(function () {
      for (var i = 0; i < total; i += 1) request(i, false);
      pump();
    }, 400);
    window.requestAnimationFrame(update);
    window.addEventListener('resize', resize, { passive: true });
  }
})();
